import React from "react";
function Footer() {
  return (
    <footer>
      <div class="footer">
        <div class="contact1">
          <h3>CONTACT</h3>
          <p>+91 953384236</p>
          <p>srigadaakshay@gmail.com</p>
          <p>Hyderabad,</p>
          <p>503111</p>
        </div>
        <div class="helpful-links">
          <h3>HELPFUL LINKS</h3>
          <p>
            <a href="#">FAQs (Frequently Asked Questions)</a>
          </p>
          <p>
            <a href="#">Customer support or help center</a>
          </p>
          <p>
            <a href="#">Terms of Service</a>
          </p>
          <p>
            <a href="#">Privacy Policy</a>
          </p>
        </div>
        <div class="about-us">
          <h3>ABOUT US</h3>
          <p>
            <a href="#">Help</a>
          </p>
          <p>
            <a href="#">Users</a>
          </p>
          <p>
            <a href="#">Legal Information</a>
          </p>
          <p>
            <a href="#">Careers</a>
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
